<template>
  <div id="wrap">
    <!-- container -->
    <div id="adminContainer">
      <div class="inner">
        <div
          style="
            width: 6px;
            height: 20px;
            background: #464775;
            float: left;
            margin-right: 10px;
          "
        ></div>
        <div style="float: left; position: relative; top: -4px">
          <h3 class="pr-3" style="font-weight: 600">대시보드</h3>
        </div>
        <div
          style="
            clear: both;
            width: 96%;
            height: 2.5px;
            background-color: #e9e9e9;
          "
        ></div>
        <!-- descBox -->
        <div class="descBox" style="margin-top: 20px">
          <div>
            <p class="tit"><b>시스템 관리</b></p>
            <div class="hr-dashboard"></div>
            <div class="area">
              <div class="area-left-txt">
                <div>회의실</div>
                <div>영상장비</div>
                <div>사용자</div>
              </div>
              <div class="area-right-txt">
                <!-- <div>{{ systemData.videoDevice }}</div> -->
                <div>{{ systemData.rooms }}</div>
                <div>{{ systemData.videoDevice }}</div>
                <div>{{ systemData.users }}</div>
              </div>
            </div>
          </div>

          <div style="margin: 0 45px">
            <p class="tit"><b>회의 사용현황</b></p>
            <div class="hr-dashboard"></div>
            <div class="area">
              <div class="area-left-txt">
                <div>진행중인 영상회의</div>
                <div>예정된 영상회의</div>
                <div>종료된 회의</div>
              </div>
              <div class="area-right-txt">
                <div>
                  {{ todayMeeting.processing + todayMeeting.confProcessing }}
                </div>
                <div>{{ todayMeeting.reserved }}</div>
                <!-- <div>{{ todayMeeting.confProcessing }}</div>
                <div>{{ todayMeeting.confReserved }}</div> -->
                <div>{{ todayMeeting.end }}</div>
              </div>
            </div>
          </div>

          <div>
            <p class="tit"><b>라이선스 관리</b></p>
            <div class="hr-dashboard"></div>
            <div class="area">
              <div class="area-left-txt">
                <div>일반(내부망) 영상회의 라이선스</div>
                <div>일반(외부망) 영상회의 라이선스</div>
                <div>고화질 영상회의 라이선스</div>
              </div>

              <div class="area-right-txt">
                <div>
                  {{ licenseInfo.mcuUseLicense }} /
                  {{ licenseInfo.mcuTotalLicense }}
                </div>
                <div>
                  {{ licenseInfo.dmzMcuUseLicense }} /
                  {{ licenseInfo.dmzMcuTotalLicense }}
                </div>
                <div>
                  {{ licenseInfo.cmsCallUseLicense }} /
                  {{ licenseInfo.cmsCallTotalLicense }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="tbw" style="margin-top: -10px">
          <div class="tbw-container">
            <div class="tbw_Top">
              <div class="tit" style="padding-top: 15px">회의 리스트</div>
              <div style="display: flex; align-items: center; margin: 20px">
                <div style="display: flex; align-items: center">
                  <date-picker
                    v-model="startDate"
                    format="YYYY-MM-DD"
                    value-type="format"
                    :lang="lang"
                    style="width: 125px; height: 30px; font-size: 13px"
                  ></date-picker>

                  <span
                    class="hyphen"
                    style="margin: 0 5px; padding-top: 0; color: #333"
                    >~</span
                  >
                  <date-picker
                    v-model="endDate"
                    format="YYYY-MM-DD"
                    value-type="format"
                    :lang="lang"
                    style="width: 125px; height: 30px; font-size: 13px"
                    :disabled-date="notBeforeStartDate"
                  ></date-picker>
                </div>
                <button class="btnPrimary" @click="searchMeeting()">
                  검색
                </button>
              </div>
            </div>
            <div class="tbw_tb01">
              <table>
                <caption>
                  회의리스트
                </caption>
                <thead>
                  <tr>
                    <th>회의날짜</th>
                    <th>회의 예약시간</th>
                    <th>회의명</th>
                    <th>상태</th>
                    <th>개설자</th>
                    <th>회의정보</th>
                    <th>망구분</th>
                    <!-- <th>수정/삭제</th> -->
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(listItem, index) in filterLimitMeeting"
                    :key="index"
                  >
                    <td>
                      <span>{{
                        getMeetingDateString(listItem)
                      }}</span>
                    </td>
                    <td>
                      <span
                        >{{ listItem.startDtime | conferenceTimeFilter }} ~
                        {{ listItem.endDtime | conferenceTimeFilter }}</span
                      >
                    </td>
                    <td>{{ listItem.title }}</td>
                    <td>
                      <span class="red" style="font-weight: bold">{{
                        statusString(listItem.status)
                      }}</span>
                    </td>
                    <td>{{ listItem.creator.name }}</td>
                    <td>
                      <a
                        @click="showInfo(listItem)"
                        class="icocom info_ico"
                      ></a>
                    </td>
                    <td>
                      {{ listItem.exMeeting === true ? '인터넷망' : '업무망' }}
                    </td>
                    <!-- <td>
                      <a
                        @click="editMeeting(listItem)"
                        class="icocom modi_ico"
                      ></a>
                    </td> -->
                  </tr>
                </tbody>
              </table>
            </div>

            <!--//tbw_tb01-->
            <div class="paging">
              <div class="boardnavi">
                <pagination
                  :records="meetingList.length"
                  v-model="page"
                  :per-page="perPage"
                />
              </div>
            </div>
          </div>
          <!--//tbw-->
        </div>
      </div>
    </div>
    <!-- 미팅 정보 -->
    <meeting-info-dialog
      :dialog="meetingInfoDialog.dialog"
      :defaultMeeting="meetingInfoDialog.meeting"
      :isAdmin="true"
      :closeDialog="closeMeetingInfoDialog"
    />

    <!-- 미팅 수정 -->
    <edit-meeting-dialog
      :dialog="editMeetingDialog.dialog"
      :meetingInfo="editMeetingDialog.meeting"
      :isTimeFixed="false"
      @editedMeeting="editedMeeting"
    />

    <!-- 미팅 수정 (열린 회의실) -->
    <open-conference-create-dialog
      :dialog="openConfEditDialog.dialog"
      :meetingInfo="openConfEditDialog.meeting"
      :mode="'edit'"
      :isAdminPage="true"
      :closeDialog="closeOpenConfEditDialog"
    />

    />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import moment from 'moment';
import EChart from '@/components/chart/echart';
import Material from 'vuetify/es5/util/colors';
import MeetingInfoDialog from '@/components/popup/MeetingInfoDialog';
import EditMeetingDialog from '@/components/popup/EditMeetingDialog';
import OpenConferenceCreateDialog from '@/components/popup/OpenConferenceCreateDialog';
import Pagination from 'vue-pagination-2';
import VueEnglishdatepicker from 'vue-englishdatepicker';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import Util from '@/util';

export default {
  filters: {
    conferenceDayFilter: function (day) {
      return moment(day).format('YYYY.MM.DD');
    },
    conferenceTimeFilter: function (time) {
      return moment(time).format('HH:mm');
    },
  },
  components: {
    MeetingInfoDialog,
    EditMeetingDialog,
    OpenConferenceCreateDialog,
    EChart,
    Pagination,
    DatePicker,
    VueEnglishdatepicker,
  },
  data: () => ({
    page: 1,
    perPage: 5,
    systemData: {
      videoDevice: 0,
      rooms: 0,
      users: 0,
    },
    todayMeeting: {
      processing: 0,
      reserved: 0,
      confReserved: 0,
      confProcessing: 0,
      licenseCount: 0,
      end: 0,
    },
    lang: {
      days: ['일', '월', '화', '수', '목', '금', '토'],
      months: [
        '1월',
        '2월',
        '3월',
        '4월',
        '5월',
        '6월',
        '7월',
        '8월',
        '9월',
        '10월',
        '11월',
        '12월',
      ],
      yearFormat: 'YYYY년',
      monthFormat: 'MM월',
      // the calendar title of month before year
      monthBeforeYear: false,
    },
    licenseInfo: {
      mcuTotalLicense: 0,
      mcuUseLicense: 0,
      cmsCallTotalLicense: 0,
      cmsCallUseLicense: 0,
      dmzMcuTotalLicense: 0,
      dmzMcuUseLicense: 0,
    },
    isActive: 'none',
    startDate: null,
    endDate: null,
    isEndActive: 'none',
    meetingList: [],
    meetingInfoDialog: {
      dialog: false,
      meeting: null,
    },
    editMeetingDialog: {
      dialog: false,
      meeting: {},
    },
    meetingEditDialog: {
      dialog: false,
      meeting: null,
    },
    openConfEditDialog: {
      dialog: false,
      meeting: null,
    },
    /* 삭제  */
    warningDialog: {
      dialog: false,
      title: '미팅 삭제',
      content: '',
      delMeetingKey: null,
      isDelUser: true,
    },
    /* 사용자 접속 채널 그래프 */
    color: Material,
    colorDefined: {
      room: Material.lightBlue.base,
      video: '#015276',
      roomVideo: '#66BB6A',
    },
    priorityData: [{ name: 'No Data', value: 0 }],
  }),
  computed: {
    filterLimitMeeting() {
      let page = this.page;
      let startPage = (page - 1) * this.perPage;
      let limitPage = startPage + this.perPage;

      return this.meetingList.slice(startPage, limitPage);
    },
  },
  watch: {
    startDate: {
      handler(val) {
        // endDate를 1주일 후로 설정.
        console.log(`startDate val`, val);
        this.endDate = moment(val).add(1, 'week').format('YYYY-MM-DD');
      },
    },
  },
  async created() {
    // this.axios.get('http://localhost:8080/server/listTest.json')
    //   .then((response) => {
    //     this.listData = response.data;
    //     console.log(this.listData);
    //   });
  },
  async activated() {
    if (!Util.hasSession(this)) return;
    if (this.$store.state.user.authorize !== 'a') {
      // 관리자가 아닌경우 로그아웃 처리
      alert('관리자가 아니기 때문에 접속 불가능 합니다.');
      this.$router.push('/403');
    }
    this.initData();
  },
  methods: {
    async initData() {
      this.startDate = moment().format('YYYY-MM-DD');
      this.endDate = moment().add(1, 'week').format('YYYY-MM-DD');

      // Get System Count
      let params = {
        siteName: this.$store.state.user.siteName,
      };
      this.$http
        .get(`/api/v1/systems/dashboard`, { params: params })
        .then((response) => {
          this.systemData = response.data;
        })
        .catch((error) => {
          console.log(error.response.data.error);
        });

      await this.dashboardLicenseCount();

      // Get Today Meeting Count
      params = {
        startDate: `${moment(moment().format('YYYY-MM-DDT00:00:00'))
          .utc()
          .format('YYYY-MM-DDTHH:mm:ss')}Z`,
        endDate: `${moment(moment().format('YYYY-MM-DDT23:59:59'))
          .utc()
          .format('YYYY-MM-DDTHH:mm:ss')}Z`,
      };
      this.$http
        .get(`/api/v1/meetings/dashboard/count`, { params: params })
        .then((response) => {
          this.todayMeeting = response.data;
        })
        .catch((error) => {
          console.log(error.response.data.error);
        });

      // Get Participant Graph Data
      params = {
        startDate: `${moment(
          moment(this.startDate).format('YYYY-MM-01T00:00:00')
        )
          .utc()
          .format('YYYY-MM-DDTHH:mm:ss')}Z`,
        endDate: `${moment(moment(this.endDate).format('YYYY-MM-DDT23:59:59'))
          .utc()
          .format('YYYY-MM-DDTHH:mm:ss')}Z`,
        siteName: this.$store.state.user.siteName,
      };

      // Get Meeting List
      params = {
        email: this.$store.state.user.email,
        showPrivated: true,
        neStatus: ['e', 'd'],
        startDate: `${moment(
          moment(this.startDate).format('YYYY-MM-DDT00:00:00')
        )
          .utc()
          .format('YYYY-MM-DDTHH:mm:ss')}Z`,
        endDate: `${moment(moment(this.endDate).format('YYYY-MM-DDT23:59:59'))
          .utc()
          .format('YYYY-MM-DDTHH:mm:ss')}Z`,
      };
      this.$http
        .get(`/api/v1/meetings`, { params: params })
        .then((response) => {
          console.log(`response.data ::: `, response.data);
          this.meetingList = response.data;
        })
        .catch((error) => {
          console.log(`error ::: `, error.response.data.error);
        });
    },
    async dashboardLicenseCount() {
      // Get License Count
      await this.$http
        .get('/api/v1/systems/dashboard/license')
        .then((response) => {
          this.licenseInfo = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async changeDashboardCount() {
      // Get System Count
      let params = {
        siteName: this.$store.state.user.siteName,
      };
      this.$http
        .get(`/api/v1/systems/dashboard`, { params: params })
        .then((response) => {
          this.systemData = response.data;
        })
        .catch((error) => {
          console.log(error.response.data.error);
        });

      await this.dashboardLicenseCount();

      // Get Today Meeting Count
      params = {
        startDate: `${moment(
          moment(this.startDate).format('YYYY-MM-DDT00:00:00')
        )
          .utc()
          .format('YYYY-MM-DDTHH:mm:ss')}Z`,
        endDate: `${moment(moment(this.endDate).format('YYYY-MM-DDT23:59:59'))
          .utc()
          .format('YYYY-MM-DDTHH:mm:ss')}Z`,
        siteName: this.$store.state.user.siteName,
      };
      this.$http
        .get(`/api/v1/meetings/dashboard/count`, { params: params })
        .then((response) => {
          this.todayMeeting = response.data;
        })
        .catch((error) => {
          console.log(error.response.data.error);
        });

      // Get Participant Graph Data
      params = {
        startDate: `${moment(
          moment(this.startDate).format('YYYY-MM-01T00:00:00')
        )
          .utc()
          .format('YYYY-MM-DDTHH:mm:ss')}Z`,
        endDate: `${moment(moment(this.endDate).format('YYYY-MM-DDT23:59:59'))
          .utc()
          .format('YYYY-MM-DDTHH:mm:ss')}Z`,
        siteName: this.$store.state.user.siteName,
      };

      // Get Meeting List
      params = {
        showPrivated: true,
        neStatus: ['e', 'd'],
        startDate: `${moment(
          moment(this.startDate).format('YYYY-MM-DDT00:00:00')
        )
          .utc()
          .format('YYYY-MM-DDTHH:mm:ss')}Z`,
        endDate: `${moment(moment(this.endDate).format('YYYY-MM-DDT23:59:59'))
          .utc()
          .format('YYYY-MM-DDTHH:mm:ss')}Z`,
        siteName: this.$store.state.user.siteName,
      };

      this.$http
        .get(`/api/v1/meetings`, { params: params })
        .then((response) => {
          this.meetingList = response.data;
        })
        .catch((error) => {
          console.log(error.response.data.error);
        });
    },
    async searchMeeting() {
      let params = {
        neStatus: ['e', 'd'],
        startDate: `${moment(
          moment(this.startDate).format('YYYY-MM-DDT00:00:00')
        )
          .utc()
          .format('YYYY-MM-DDTHH:mm:ss')}Z`,
        endDate: `${moment(moment(this.endDate).format('YYYY-MM-DDT23:59:59'))
          .utc()
          .format('YYYY-MM-DDTHH:mm:ss')}Z`,
      };
      this.$http
        .get(`/api/v1/meetings`, { params: params })
        .then((response) => {
          this.meetingList = response.data;
        })
        .catch((error) => {
          console.log(error.response.data.error);
        });

      this.changeDashboardCount();
    },
    allowedStartDates(d) {
      return moment(d).format('YYYY-MM-DD') >= moment().format('YYYY-MM-DD');
    },
    allowedEndDates(d) {
      return (
        moment(d).format('YYYY-MM-DD') >=
        moment(this.startDate).format('YYYY-MM-DD')
      );
    },
    showDatePicker() {
      if (this.isActive === 'none') {
        this.isActive = '';
        this.isEndActive = 'none';
      } else {
        this.isActive = 'none';
      }
    },
    startDateChange() {
      this.isActive = 'none';
      // this.startDate(this.startDate);
    },
    showEndDatePicker() {
      if (this.isEndActive === 'none') {
        this.isEndActive = '';
        this.isActive = 'none';
      } else {
        this.isEndActive = 'none';
      }
    },
    endDateChange() {
      this.isEndActive = 'none';
      // this.startDate(this.startDate);
    },
    statusString(status) {
      if (status === 'r') {
        return '예약중';
      } else if (status === 's') {
        return '진행중';
      } else if (status === 'e') {
        return '종료';
      } else {
        return '';
      }
    },
    showInfo(meeting) {
      console.log(`meeting : `, meeting);
      this.meetingInfoDialog.meeting = meeting;
      this.meetingInfoDialog.dialog = true;
    },
    closeMeetingInfoDialog() {
      this.meetingInfoDialog.dialog = false;
    },
    editMeeting(meeting) {
      if (meeting.isOpenConference) {
        this.editMeetingDialog.meeting = meeting;
        this.editMeetingDialog.dialog = true;
      } else {
        this.editMeetingDialog.meeting = meeting;
        this.editMeetingDialog.dialog = true;
      }
    },
    closeMeetingEditDialog(isInit) {
      this.meetingEditDialog.dialog = false;
      if (isInit) {
        this.searchMeeting();
      }
    },
    closeOpenConfEditDialog(isInit) {
      this.openConfEditDialog.dialog = false;
      if (isInit) {
        this.searchMeeting();
      }
    },
    deleteMeeting(meeting) {
      this.warningDialog.content = `${meeting.title}을 <br>삭제 하시겠습니까?`;
      this.warningDialog.delMeetingKey = meeting.meetingKey;
      this.warningDialog.dialog = true;
    },
    editedMeeting() {
      this.editMeetingDialog.dialog = false;
    },
    async closeWarningDialog(ret) {
      if (ret === 'ok') {
        let params = {
          meetingKeys: this.warningDialog.delMeetingKey,
        };
        await this.$http
          .delete('/api/v1/meetings', { params: params })
          .then((response) => {
            if (response.data === 'ok') {
              this.searchMeeting();
            }
          })
          .catch((error) => {
            console.log(error);
          });
        this.warningDialog.delId = null;
        this.warningDialog.dialog = false;
      }
    },
    notBeforeStartDate(date) {
      return date < new Date(this.startDate);
    },
    // 회의 시작 날짜와 종료 날짜가 다른경우 날짜 표시 방법 수정
    getMeetingDateString (item) {
      const startDate = moment(item.startDtime).format('YYYY.MM.DD');
      const endDate = moment(item.endDtime).format('YYYY.MM.DD');
      if (startDate === endDate) {
        return startDate;
      } else {
        const displayEndDate = moment(item.endDtime).format('MM.DD');
        return `${startDate} ~ ${displayEndDate}`;
      }
    }
  },
};
</script>
<style scoped lang="stylus"></style>



// WEBPACK FOOTER //
// src/pages/admin/sections/Dashboard.vue